export const wizardEnabledLanguages = ['en', 'fr', 'es', 'ja', 'de', 'pt'];